import { TNoShowListItem } from "../../../types";
import { Container, CreatorContainer, MeetingTitle, Title, LabelContainer } from "./index.styles";
import { FadeLoader } from "react-spinners";
import UI from "@mile-meeting/mile-ui";
import { useState } from "react";
import { useRecoilValue } from "recoil";
import { member } from "recoil/recoilState";
import { UserRole } from "utils/role";

const getDateString = (date: string) => {
  const dateObj = new Date(date);
  const days = ["일", "월", "화", "수", "목", "금", "토"];

  return `${dateObj.getFullYear()} - ${(dateObj.getMonth() + 1).toString().padStart(2, "0")} - ${dateObj.getDate().toString().padStart(2, "0")} (${days[dateObj.getDay()]})`;
};

const getTimeString = (time: string) => {
  const timeObj = new Date(time);
  return `${timeObj.getHours().toString().padStart(2, "0")}:${timeObj.getMinutes().toString().padStart(2, "0")}`;
};

const NoShowListItem = ({
  noShowInfo,
  isCanceling,
  onClickTitle,
  onClickCancel,
  onClickCancelRequest,
}: {
  noShowInfo: TNoShowListItem;
  isCanceling: boolean;
  onClickTitle: () => void;
  onClickCancel: () => Promise<void>;
  onClickCancelRequest: () => Promise<void>;
}) => {
  const [loadingCancel, setLoadingCancel] = useState<boolean>(false);
  const [loadingCancelRequest, setLoadingCancelRequest] = useState<boolean>(false);
  const memberInfo = useRecoilValue(member);

  const onHandleCancel = async () => {
    if (loadingCancel || isCanceling) return;
    setLoadingCancel(true);
    await onClickCancel();
    setLoadingCancel(false);
  };

  const onHandleCancelRequest = async () => {
    if (loadingCancelRequest || isCanceling) return;
    setLoadingCancelRequest(true);
    await onClickCancelRequest();
    setLoadingCancelRequest(false);
  };
  return (
    <Container>
      <MeetingTitle>
        <Title>
          <div
            onClick={onClickTitle}
            style={{ maxWidth: noShowInfo.isRecurring ? "calc(100% - 66px)" : "100%", cursor: "pointer" }}
          >
            <UI.Typography
              type="body01 normal"
              fontStyle="bold"
              color="var(--alias-color-label-neutral)"
              style={{
                borderBottom: "1px solid var(--alias-color-line-strong)",
                width: "max-content",
                maxWidth: "100%",
                cursor: "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {noShowInfo.isPrivate ? "비공개 회의" : noShowInfo.title}
            </UI.Typography>
          </div>
          {noShowInfo.isRecurring && <UI.Tag label="반복 예약" size="small" color="skyblue" />}
        </Title>
        <CreatorContainer>
          <div className="label">
            <UI.Icon name="person" size={16} color="var(--alias-color-label-alternative)" />
            <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
              예약자
            </UI.Typography>
          </div>
          <UI.Typography
            type="label01"
            fontStyle="regular"
            color="var(--alias-color-label-normal)"
            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
          >
            {noShowInfo.isPrivate ? "비공개" : noShowInfo.creatorName}
          </UI.Typography>
        </CreatorContainer>
      </MeetingTitle>
      <LabelContainer minWidth={120} maxWidth={140}>
        <UI.Typography type="label01" fontStyle="regular" color="var(--alias-color-label-normal)">
          {getDateString(noShowInfo.rsvStartTime)}
        </UI.Typography>
      </LabelContainer>
      <LabelContainer minWidth={100} maxWidth={120}>
        <UI.Typography type="label01" fontStyle="regular" color="var(--alias-color-label-normal)">
          {getTimeString(noShowInfo.rsvStartTime)} - {getTimeString(noShowInfo.rsvEndTime)}
        </UI.Typography>
      </LabelContainer>
      <LabelContainer minWidth={100} maxWidth={100}>
        <UI.Typography type="label01" fontStyle="bold" color="var(--global-color-pink-40)">
          {noShowInfo.noshowNum}
        </UI.Typography>
      </LabelContainer>
      <LabelContainer minWidth={237} maxWidth={237}>
        {noShowInfo.cancelability &&
        noShowInfo.isRecurring &&
        (memberInfo?.role === UserRole.SuperAdmin || memberInfo?.role === UserRole.Owner) ? (
          <>
            <UI.Button
              style={{ gap: 0, outline: "none" }}
              title="취소 요청 보내기"
              size="small"
              type="outlined"
              disabled={isCanceling}
              onClick={onHandleCancelRequest}
              suffixIcon={
                <div
                  style={{
                    transform: "scale(0.3)",
                    display: "inline-flex",
                    width: 16,
                  }}
                >
                  <FadeLoader color="#3885FF" height={16} radius={4} width={4} />
                </div>
              }
              showSuffixIcon={loadingCancelRequest}
            />
            <UI.Button
              style={{ gap: 0, outline: "none" }}
              title="취소하기"
              size="small"
              primary={false}
              disabled={isCanceling}
              onClick={onHandleCancel}
              suffixIcon={
                <div
                  style={{
                    transform: "scale(0.3)",
                    display: "inline-flex",
                    width: 16,
                  }}
                >
                  <FadeLoader color="#3885FF" height={16} radius={4} width={4} />
                </div>
              }
              showSuffixIcon={loadingCancel}
            />
          </>
        ) : null}
      </LabelContainer>
    </Container>
  );
};

export default NoShowListItem;
